class TokenHelper {
  static parseJwtToken(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    var jsonToken = JSON.parse(window.atob(base64));
    return jsonToken;
  }
}

export default TokenHelper;